/**
 * Composition root for project storage. Swap or add stores here (e.g. a cloud store) without
 * touching the editor.
 */
import { FolderProjectStore } from './folder-store.ts';
import { projectFolders } from './folders.ts';
import type { ProjectStore } from './types.ts';

export const projectStore: ProjectStore = new FolderProjectStore({ folders: projectFolders });
